import React, { useEffect } from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import { isScrollingDisabled } from '../../ducks/UI.duck';
import {
    Page,
    LayoutWrapperTopbar,
    LayoutWrapperMain,
    LayoutWrapperFooter,
    Footer,
    LayoutWrapperSideNav,
    LayoutSideNavigation,
} from '../../components';
import { TopbarContainer } from '../../containers';
import { ensureCurrentUser } from '../../util/data';
import css from './BalancePage.css';
import { fetchCurrentUser } from '../../ducks/user.duck';
import { balancePageTabs } from './balancePageTabs';
import { BalanceTab } from './BalanceTab';
import { RewardsTab } from './RewardsTab';

export const BalancePage = ({ scrollingDisabled, tab, getCurrentUser }) => {
    const isHistoryBalancePage = tab === 'history';
    const isRewardsPage = tab === 'rewards';

    const schemaTitle = 'Deine Bilanz';
    const schemaDescription = 'Hier findest Du die Gesamtzahl und Historie deiner Credits.';

    useEffect(() => {
        getCurrentUser();
    }, []);

    return (
        <Page
            scrollingDisabled={scrollingDisabled}
            contentType="website"
            description={schemaDescription}
            title={schemaTitle}
            schema={{
                '@context': 'http://schema.org',
                '@type': 'WebPage',
                description: schemaDescription,
                name: schemaTitle,
                image: ['https://horsedeal.imgix.net/static/social-image-1200x630.webp'],
            }}
        >
            <LayoutSideNavigation>
                <LayoutWrapperTopbar>
                    <TopbarContainer currentPage="BalancePage" />
                </LayoutWrapperTopbar>
                <LayoutWrapperSideNav
                    className={css.sideNav}
                    tabs={balancePageTabs({
                        selectedPage: isHistoryBalancePage ? 'BalancePage' : 'RewardsPage',
                    })}
                />
                <LayoutWrapperMain
                    className={css.layout}
                    blobBackground
                    blobProps={{
                        xDistance: 20,
                        baseWidth: 760,
                    }}
                >
                    {isHistoryBalancePage && <BalanceTab />}
                    {isRewardsPage && <RewardsTab />}
                </LayoutWrapperMain>
                <LayoutWrapperFooter>
                    <Footer />
                </LayoutWrapperFooter>
            </LayoutSideNavigation>
        </Page>
    );
};

const mapStateToProps = ({ UI, user: { currentUser } }) => ({
    scrollingDisabled: isScrollingDisabled({ UI }),
    currentUser: ensureCurrentUser(currentUser),
});

const mapDispatchToProps = dispatch => ({
    getCurrentUser: () => dispatch(fetchCurrentUser()),
});

export default compose(withRouter, connect(mapStateToProps, mapDispatchToProps))(BalancePage);
